<template>
    <div>
        <h1 class="display-heading">Set Free Time Slots</h1>
        <p>
            Set time slots from
            <b>{{titleDatesFrom}}</b>.
        </p>
        <p>You are allowed to set more than 1 time slot per day.</p>
        <p>Each video consultation estimated to take 10 minutes, however the time slots are divided to 30 minute each to accommodate unforeseen circumstances.</p>

        <div v-for="(day, dayIndex) in dates" :key="dayIndex" class="card mb-3">
            <div class="card-header">{{day.text}}</div>
            <div class="card-body">
                <span v-if="day.slots.length === 0" class="font-italic">No slots defined</span>

                <div v-else class="timeslots-wrapper">
                    <div
                        v-for="(slot, slotIndex) in day.slots"
                        :key="slotIndex"
                        class="timeslot-item"
                    >
                        <div v-show="slot.isBooked" class="slot-booked">
                            <div class="booked-indicator"></div>
                        </div>
                        <div
                            class="text-nowrap"
                        >{{convertToUserReadableTime(slot.from)}} - {{convertToUserReadableTime(slot.to)}}</div>
                        <div v-show="!slot.isBooked" class="slot-delete">
                            <a
                                href="javascript: void(0);"
                                class="delete-button"
                                @click="removeTimeslot(dayIndex, slotIndex)"
                            >
                                <i class="fas fa-trash-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <p
                    v-if="day.slots.length > 0"
                    class="mt-3"
                >Click red color dustbin icon to delete the specific timeslot.</p>

                <div v-if="hasBookedSlot(dayIndex)" class="d-flex align-items-center mt-3">
                    <div class="booked-indicator mr-3"></div>indicates the time slot has been booked by a patient.
                </div>

                <p
                    v-show="day.isMessageShown"
                    :class="['mt-3', {'text-danger': day.submitHasError}]"
                >{{day.submitMessage}}</p>

                <div class="mt-3">
                    <button
                        class="btn btn-primary btn-primary mr-2"
                        @click="addSlotForDate(day.start)"
                    >Add Slot</button>
                    <button
                        class="btn btn-primary btn-primary-insv mr-2"
                        @click="saveTimeSlot(dayIndex)"
                    >Save All</button>
                    <button class="btn btn-secondary" @click="repullTimeslots(dayIndex)">Cancel</button>
                </div>
            </div>
        </div>

        <!-- modal -->
        <popup-modal ref="popupAddSlot" title="Create Slot">
            <template slot="content">
                <form data-vv-scope="timeslot-add">
                    <div class="form-group row">
                        <label class="col-3 col-form-label">Time From</label>
                        <div class="col">
                            <select
                                name="timeFrom"
                                v-model="selectedDateTimeFrom"
                                data-vv-validate-on="blur"
                                data-vv-as="Time From"
                                v-validate="'required'"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('timeslot-add.timeFrom')
                                }"
                            >
                                <option
                                    v-for="(time,index) in timesFrom"
                                    :key="index"
                                    :value="time.value"
                                >{{time.text}}</option>
                            </select>
                            <div
                                v-show="validationErrors.has('timeslot-add.timeFrom')"
                                class="invalid-feedback"
                            >{{ validationErrors.first('timeslot-add.timeFrom') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-3 col-form-label">Time To</label>
                        <div class="col">
                            <select
                                class="form-control"
                                name="timeTo"
                                v-model="selectedDateTimeTo"
                                data-vv-as="Time To"
                                data-vv-validate-on="blur"
                                v-validate="'required'"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('timeslot-add.timeTo')
                                }"
                            >
                                <option
                                    v-for="(time,index) in timesTo"
                                    :key="index"
                                    :value="time.value"
                                >{{time.text}}</option>
                            </select>
                            <div
                                v-show="validationErrors.has('timeslot-add.timeTo')"
                                class="invalid-feedback"
                            >{{ validationErrors.first('timeslot-add.timeTo') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-3"></div>
                        <div class="col">
                            <p>Apply selected timeslots for the days below:</p>

                            <div class="form-check">
                                <label class="form-check-label d-flex align-items-center">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="selectAll"
                                    />
                                    <span>Select All</span>
                                </label>
                            </div>

                            <div class="form-check" v-for="(date, index) in dateCheckboxes" :key="index">
                                <label class="form-check-label d-flex align-items-center">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="date.isSelected"
                                    />
                                    <span>{{ date.text }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
                <p v-if="addTimeslotMessage">
                    {{ addTimeslotMessage }}
                </p>
            </template>
            <template slot="footer">
                <button
                    @click="createSlotForDay"
                    class="btn btn-primary btn-primary-insv mr-2"
                >Create</button>
                <button @click="cancelCreateSlot" class="btn btn-secondary">Cancel</button>
            </template>
        </popup-modal>
        <!-- modal -->
    </div>
</template>

<script>
import {
    convertToUserReadableDate,
    convertToUserReadableTime,
    convertToUserReadableDateWithDay
} from '@/utilities';
import popupModal from '@/components/popup-modal';
import moment from 'moment';
export default {
    'name': 'DoctorCreateTimeslot',
    'components': {
        popupModal
    },
    'computed': {
        timesFrom () {
            let day = moment(this.selectedDate);

            let hours = 23;

            let times = [];

            for (let i = 0; i <= hours; i++) {
                let time = day.clone().add(i, 'hours');
                times.push({
                    'text': convertToUserReadableTime(time),
                    'value': time.toISOString(true)
                });
            }

            return times;
        },
        timesTo () {
            return this.timesToList.filter(s => {
                return moment(s.value).isAfter(
                    moment(this.selectedDateTimeFrom)
                );
            });
        },
        titleDatesFrom () {
            if (this.dates.length > 0) {
                return `${convertToUserReadableDate(
                    this.dates[0].start
                )} to ${convertToUserReadableDate(
                    this.dates[this.dates.length - 1].start
                )}`;
            }
            return '-';
        },
        selectedDates () {
            return this.dateCheckboxes.map((d) => d.isSelected);
        }
    },
    'watch': {
        timesFrom (val) {
            if (!this.selectedDateTimeFrom && val.length > 0) {
                this.selectedDateTimeFrom = val[0].start;
            }

            this.timesToList = val;
        },
        timesTo (val) {
            if (val.length > 0) {
                this.selectedDateTimeTo = val[0].start;
            }
        },
        selectedDate () {
            this.selectedDateTimeFrom = '';
            this.selectedDateTimeTo = '';
        },
        selectAll (val) {
            if (val) {
                this.dateCheckboxes.forEach((d) => (d.isSelected = true));
            } else {
                let selected = this.selectedDates.filter(v => !!v);

                if (selected.length === this.dateCheckboxes.length) {
                    this.dateCheckboxes.forEach((d) => (d.isSelected = false));
                }
            }
        },
        selectedDates (val) {
            let selected = val.filter(v => !!v);

            if (selected.length === this.dateCheckboxes.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        }
    },
    data () {
        return {
            'dates': [],
            'selectedDate': 0,
            'selectedDateTimeFrom': '',
            'selectedDateTimeTo': '',
            'timesToList': [],
            'selectAll': false,
            'dateCheckboxes': [],
            'addTimeslotMessage': ''
        };
    },
    mounted () {
        let today = moment().startOf('day');
        let maxDays = 14;

        for (let i = 1; i <= maxDays; i++) {
            let day = today.clone().add(i, 'days');

            this.dateCheckboxes.push({
                'text': convertToUserReadableDateWithDay(day),
                'start': day.toISOString(true),
                'isSelected': false,
                'slots': []
            });

            this.dates.push({
                'text': convertToUserReadableDateWithDay(day),
                'start': day.toISOString(true),
                'end': day.endOf('day').toISOString(true),
                'slots': [],
                'isMessageShown': false,
                'submitMessage': '',
                'submitHasError': false
            });
        }

        this.selectedDate = this.dates[0].start;

        this.getDoctorTimeslots(
            this.dates[0].start,
            this.dates[this.dates.length - 1].end
        );
    },
    'methods': {
        getDoctorTimeslots (from, to, dateIndex = -1) {
            this.axios
                .post('Doctor/GetDoctorTimeSlots', {
                    's': from,
                    'e': to,
                    'eb': false
                })
                .then(({ data }) => {
                    if (dateIndex === -1) {
                        this.dates.forEach(date => {
                            date.slots = [];
                        });
                    } else {
                        if (this.dates[dateIndex]) {
                            this.dates[dateIndex].slots = [];
                        }
                    }

                    let doctorTimeslots = data.data;

                    if (doctorTimeslots.length > 0) {
                        let myTimeslots = doctorTimeslots[0];
                        myTimeslots.ts.forEach(slot => {
                            let found = this.dates.find(d => {
                                return moment(d.start).isSame(slot.f, 'day');
                            });
                            found.slots.push({
                                'from': slot.f,
                                'to': slot.t,
                                'isBooked': slot.ib
                            });
                        });
                    }
                });
        },
        addSlotForDate (date) {
            this.selectedDate = date;

            this.dateCheckboxes.forEach((checkbox) => {
                checkbox.slots = [];
                checkbox.isSelected = false;

                if (checkbox.start === date) {
                    checkbox.isSelected = true;
                }
            });

            this.$refs.popupAddSlot.show();
        },
        saveTimeSlot (dateIndex) {
            if (this.dates[dateIndex]) {
                let day = this.dates[dateIndex];

                day.submitHasError = false;
                day.isMessageShown = true;
                day.submitMessage = 'Saving time slots...';

                let slots = day.slots.map(s => ({
                    'f': s.from,
                    't': s.to
                }));

                this.axios
                    .post('/Doctor/CreateFreeTimeSlot', {
                        's': day.start,
                        'e': day.end,
                        'ts': slots
                    })
                    .then(() => {
                        day.submitMessage = 'Time slots saved successfully!';
                        this.getDoctorTimeslots(day.start, day.end, dateIndex);
                    })
                    .catch(error => {
                        day.submitHasError = true;
                        day.submitMessage = error.response.data
                            ? error.response.data.message
                            : 'Error saving time slots. Please try again.';
                    });
            }
            // get index of array to save
        },
        groupTimeslotsByDay (timeslots) {
            let slots = [];

            let slotListWithDates = timeslots.map(slot => ({
                'sessionId': slot.sessionId,
                'startTime': slot.startTime,
                'endTime': slot.endTime,
                'date': convertToUserReadableDateWithDay(slot.startTime),
                'startTimestamp': moment(slot.startTime).unix()
            }));

            slotListWithDates.forEach(slot => {
                var found = slots.find(s => s.date === slot.date);

                if (found) {
                    found.times.push(slot);
                } else {
                    slots.push({
                        'date': slot.date,
                        'times': [slot]
                    });
                }
            });

            slots.forEach(slot => {
                slot.times = slot.times.sort((s1, s2) => {
                    return s1.startTimestamp - s2.startTimestamp;
                });
            });

            return slots;
        },
        createSlotForDay () {
            this.$validator.validateAll('timeslot-add').then(passed => {
                let selected = this.selectedDates.filter(v => !!v);

                if (selected.length === 0) {
                    passed = false;
                    this.addTimeslotMessage = 'At least one date is required to be selected.';
                }

                if (passed) {
                    this.dateCheckboxes.forEach((thisDate) => {
                        if (thisDate.isSelected) {
                            let momentDate = moment(thisDate.start);

                            let hourFrom = moment(this.selectedDateTimeFrom).hour();
                            let hourTo = moment(this.selectedDateTimeTo).hour();

                            let addThreshold = (hourTo - hourFrom) * 2;

                            for (let i = 0; i < addThreshold; i++) {
                                let timeSlotFrom = momentDate.clone().add(hourFrom, 'h');
                                timeSlotFrom = timeSlotFrom.add(i * 30, 'm');
                                let timeSlotTo = timeSlotFrom.clone().add(30, 'm');

                                let formattedTimeSlotFrom = timeSlotFrom.format('YYYY-MM-DDTHH:mm:SS');

                                let formattedTimeSlotTo = timeSlotTo.format('YYYY-MM-DDTHH:mm:SS');
                                let dateData = this.dates.find(d => d.start === thisDate.start);

                                if (dateData) {
                                    let found = dateData.slots.find(s => s.from === formattedTimeSlotFrom);

                                    if (!found) {
                                        dateData.slots.push({
                                            'from': formattedTimeSlotFrom,
                                            'to': formattedTimeSlotTo
                                        });
                                    }
                                }
                            }

                            // sort
                            let dateData = this.dates.find(d => d.start === thisDate.start);
                            if (dateData) {
                                dateData.slots.sort((a, b) => {
                                    let fromA = moment(a.from);
                                    let fromB = moment(b.from);

                                    return fromA.unix() - fromB.unix();
                                });
                            }
                        }
                    });

                    let allDates = this.dates.length;

                    for (let i = 0; i < allDates; i++) {
                        this.saveTimeSlot(i);
                    }

                    this.cancelCreateSlot();
                }
            });
        },
        cancelCreateSlot () {
            this.validationErrors.clear('timeslot-add');

            this.$refs.popupAddSlot.hide();
        },
        convertToUserReadableTime (val) {
            return convertToUserReadableTime(val);
        },
        hasBookedSlot (dayIndex) {
            let booked = this.dates[dayIndex].slots.filter(s => s.isBooked);
            return booked.length > 0;
        },
        removeTimeslot (dayIndex, slotIndex) {
            if (this.dates[dayIndex]) {
                let date = this.dates[dayIndex];
                // show message to save
                date.isMessageShown = true;
                date.submitHasError = false;
                date.submitMessage =
                    'Please click "Save All" to confirm your time slots.';
                date.slots.splice(slotIndex, 1);
            }
        },
        repullTimeslots (dayIndex) {
            if (this.dates[dayIndex]) {
                let day = this.dates[dayIndex];
                this.getDoctorTimeslots(day.start, day.end, dayIndex);
            }
        }
    }
};
</script>

<style>
.timeslots-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-bottom: -15px;
}

.timeslots-wrapper .timeslot-item {
    margin-right: 15px;
    margin-bottom: 15px;
    color: #009344;
    border: 1px solid #009344;
    padding: 10px;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
}

.timeslots-wrapper .timeslot-item .slot-booked {
    margin-right: 10px;
}

.booked-indicator {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #dc3545;
}

.timeslots-wrapper .timeslot-item .slot-delete {
    margin-left: 10px;
}

.timeslots-wrapper .timeslot-item .slot-delete a.delete-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    color: #dc3545;
    text-decoration: none;
}
</style>
